/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const OpportunityAffiliateJsonApiModel = {
  id: "",
  opportunity: {
    jsonApi: "hasOne",
    type: "opportunities",
  },
  "opportunity-id": "",
  name: "",
  description: "",
  "created-at": "",
  "updated-at": "",
};
